import {
  successMessages,
  googleSocialLinkConstants,
  toastTypes,
} from "../../constants";
import { customToast } from "../../../../shared";
import { googleSocialLinkService } from "../../services";
import { success, withSpinner } from "../../../../redux/actions/utilities";

const { STORE_DATA, UPDATE_GOOGLE_SOCIAL_LINK } = googleSocialLinkConstants;

const { UPDATED_SUCCESSFULLY } = successMessages;

//Fetching brand locations paginated data
function getBrandLocations(body) {
  return (dispatch) => {
    withSpinner(dispatch, STORE_DATA, () =>
      googleSocialLinkService
        .getBrandLocations(body)
        .then(
          (response) => {
            dispatch(success(response, STORE_DATA));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
}

//Function to update brand location data
function updateBrandLocations(body) {
  return (dispatch) => {
    return withSpinner(dispatch, STORE_DATA, () =>
      googleSocialLinkService
        .updateBrandLocations(body)
        .then(
          (response) => {
            dispatch(success(response, UPDATE_GOOGLE_SOCIAL_LINK));
            customToast(UPDATED_SUCCESSFULLY, toastTypes.SUCCESS);
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
            throw error;
          }
        )
    );
  };
}

//Exporting mark actions for other files
export const googleSocialLinkActions = {
  getBrandLocations,
  updateBrandLocations,
};
